import { render, staticRenderFns } from "./ModifyOtherItem.vue?vue&type=template&id=15251276&scoped=true"
import script from "./ModifyOtherItem.vue?vue&type=script&lang=js"
export * from "./ModifyOtherItem.vue?vue&type=script&lang=js"
import style0 from "./ModifyOtherItem.vue?vue&type=style&index=0&id=15251276&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15251276",
  null
  
)

export default component.exports